import React from "react";
import WidgetIcon from "../../icons/widget-icon/WidgetIcon";
import ConstantsImages from "../../../constants/ConstantsImages";
import WidgetTooltipWrapper from "../widget-tooltip-wrapper/WidgetTooltipWrapper";
import ConstantsTexts from "../../../constants/ConstantsTexts";

const WidgetSearchIcon = ({ showSearchTerminal, handleSearchTerminalIconClick, editMode = false }) => {
  const icon = showSearchTerminal ? ConstantsImages.CLOSE_4_IMAGE : ConstantsImages.SEARCH_IMAGE;
  const backgroundColor = editMode ? "#C9CADE" : showSearchTerminal ? "#E4E4E4" : "#2b308b";
  const cursor = editMode ? "default" : "pointer";

  const getIconDimensions = () => {
    if (showSearchTerminal) {
      return { width: "1.1rem", height: "1.2rem" };
    }
    return { width: "1.6rem", height: "1.6rem" };
  };

  const dataHoverDisabled = editMode || showSearchTerminal;

  const iconElement = (
    <WidgetIcon
      iconProp={icon}
      widthIconProp={getIconDimensions().width}
      heightIconProp={getIconDimensions().height}
      backgroundColorProp={backgroundColor}
      cursorProp={cursor}
      handleOnClickProp={handleSearchTerminalIconClick}
      customClassNameProp="widget-search-icon"
      dataHoverDisabled={dataHoverDisabled}
    />
  );

  // Only show tooltip when search terminal is closed
  if (showSearchTerminal) {
    return iconElement;
  }

  return <WidgetTooltipWrapper content={ConstantsTexts.CODE_2}>{iconElement}</WidgetTooltipWrapper>;
};

export default WidgetSearchIcon;
